import { Component, inject, OnInit } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { Firestore } from "@angular/fire/firestore";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { JackpotTriggersService } from "../services/jackpot-triggers.service";

@Component({
  selector: "app-lucky-nos-popup",
  templateUrl: "./lucky-nos-popup.component.html",
  styleUrls: ["./lucky-nos-popup.component.scss"],
})
export class LuckyNosPopupComponent implements OnInit {
  luckyNosDetails: any;
  languageCode: string = "en";
  lnPopupTranslatedData: any;
  title: string;
  private matDialogRef = inject(MatDialogRef<LuckyNosPopupComponent>);
  public data = inject(MAT_DIALOG_DATA);
  public translate = inject(TranslateService);
  private authService = inject(AuthService);
  private matDialog = inject(MatDialog);
  private router = inject(Router);
  private angularFirestore = inject(AngularFirestore);
  private jackpotTriggerService = inject(JackpotTriggersService);
  private firestore = inject(Firestore);
  public userId: string;


  constructor() { }

  async ngOnInit() {

    await this.authService.getUid("LuckyNosPopupComponent").then((uid) => {
      this.userId = uid;
    })
    this.luckyNosDetails = this.data;
    this.authService?.userDetails$?.subscribe((user: any) => {
      this.languageCode = user?.language_code ? user?.language_code : "en";
      this.jackpotTriggerService?.getTranslatedData(this.languageCode)?.subscribe(
        (data) => {
          this.lnPopupTranslatedData = data?.["lucky_number_popup"];
          this.title = this.lnPopupTranslatedData?.title;
        },
        (err) => {
          return err;
        }
      );
    });


    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );
    if (this.data) {
      const path_id = "dQ2JLcXGOr5fbVp8gyIf";
      const doc_data = {
        auto_show: false,
        viewed: true,
        view_count: this.data.view_count + 1,
      };
      const dv = { docId: this.data.id };
      const method = "update";

      this.authService.getV2CloudFunction("updatefirestoredoc", {
        path_id,
        doc_data,
        dv,
        method,
      }).subscribe({
        error: (error) => {
          console.error("Error updating Firestore document:", error);
          return error;
        }
      });
    }
  }

  closePopup() {
    this.matDialog.closeAll();
  }

  goToSyndicates() {
    this.matDialog.closeAll();
    this.router.navigateByUrl(this.luckyNosDetails?.destination);
    {
    }
  }
}
